import {
  tabs,
  case_cards,
  case_rows,
  investigations_columns,
  type_cards,
  repeat_cards,
  repeat_groups,
  case_classification_options,
  workflow_stage_options,
  impact_options,
  reach_options,
  case_status_options,
  initial_incident_sequence
} from './incidents_cases_data';
import {
  create_report_form,
  clone_deep,
  status_meta_from_label,
  drawer_status_class,
  action_status_class,
  record_icon_for_type,
  build_case_drawer_catalog,
  create_generic_case_drawer
} from './incidents_cases_helpers';

let incident_sequence = initial_incident_sequence;

function score_from_label(value) {
  const score_value = Number.parseInt(String(value || '1').split(' - ')[0], 10) || 1;
  return score_value;
}

function severity_label_from_score(severity) {
  if (severity >= 16) return 'Critical';
  if (severity >= 9) return 'High';
  return 'Medium';
}

function build_incident_row(form, severity) {
  const row = {
    ref: `IC-${String(incident_sequence).padStart(3, '0')}`,
    case: (form.title || '').trim(),
    classification: form.classification,
    severity,
    severity_label: severity_label_from_score(severity),
    investigator: form.investigator.trim() || 'Unassigned',
    stage: form.workflow_stage,
    status: status_meta_from_label(form.status),
    lock: form.confidential
  };
  return row;
}

export default {
  name: 'ComplyonIncidentsCases',
  data: () => ({
    tabs,
    active_tab: 'cases',
    case_cards,
    case_rows,
    investigations_columns,
    type_cards,
    repeat_cards,
    repeat_groups,
    case_drawer_catalog: build_case_drawer_catalog(),
    active_case_drawer_key: null,
    report_modal_open: false,
    case_classification_options,
    workflow_stage_options,
    impact_options,
    reach_options,
    case_status_options,
    report_form: create_report_form()
  }),
  computed: {
    active_case_drawer() {
      if (!this.active_case_drawer_key) return null;
      const active_case_drawer = Reflect.get(this.case_drawer_catalog, this.active_case_drawer_key) || null;
      return active_case_drawer;
    }
  },
  mounted() {
    this.sync_overlay_state();
    document.addEventListener('keydown', this.handle_keydown);
  },
  beforeUnmount() {
    if (typeof document !== 'undefined') {
      document.body.classList.remove('incidents-overlay-open');
    }

    document.removeEventListener('keydown', this.handle_keydown);
  },
  watch: {
    report_modal_open() {
      this.sync_overlay_state();
    },
    active_case_drawer_key() {
      this.sync_overlay_state();
    }
  },
  methods: {
    sync_overlay_state() {
      if (typeof document === 'undefined') return;
      document.body.classList.toggle('incidents-overlay-open', this.report_modal_open || Boolean(this.active_case_drawer_key));
    },
    handle_keydown(event) {
      if (event.key !== 'Escape') return;
      if (this.report_modal_open) return this.close_report_modal();
      if (this.active_case_drawer_key) this.close_case_drawer();
    },
    set_tab(tab_id) {
      this.active_tab = tab_id;
      this.close_case_drawer();
      if (this.report_modal_open) this.close_report_modal();
    },
    open_case_drawer(row_or_ref) {
      const case_ref = typeof row_or_ref === 'string' ? row_or_ref : row_or_ref?.ref;
      const case_drawer = Reflect.get(this.case_drawer_catalog, case_ref);
      if (!case_ref || !case_drawer) return;

      this.report_modal_open = false;
      this.active_case_drawer_key = case_ref;
      this.$nextTick(() => {
        const drawer_body = this.$refs.caseDrawerBody;
        if (drawer_body) drawer_body.scrollTop = 0;
      });
    },
    close_case_drawer() {
      this.active_case_drawer_key = null;
    },
    open_report_modal() {
      this.close_case_drawer();
      this.report_form = create_report_form();
      this.report_modal_open = true;
    },
    close_report_modal() {
      this.report_modal_open = false;
    },
    drawer_status_class,
    action_status_class,
    record_icon_for_type,
    submit_report_modal() {
      const title = (this.report_form.title || '').trim();
      if (!title) return;

      const impact_score = score_from_label(this.report_form.impact);
      const reach_score = score_from_label(this.report_form.reach);
      const severity = impact_score * reach_score;
      const row = build_incident_row(this.report_form, severity);

      this.case_rows.unshift(row);
      Reflect.set(this.case_drawer_catalog, row.ref, create_generic_case_drawer(row, clone_deep(this.report_form)));
      incident_sequence += 1;
      this.tabs = this.tabs.map((tab) => (tab.id === 'cases' ? { ...tab, count: this.case_rows.length } : tab));
      this.close_report_modal();
      this.open_case_drawer(row.ref);
    }
  }
};
